let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6NzTB")).then(() => parcelRequire('aVIPl'));